// Debounce function
export const debounce = (func: Function, wait: number) => {
  let timeout: NodeJS.Timeout;
  return function executedFunction(...args: any[]) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
};

// Check if it's a mobile device
export const isMobileDevice = () => {
  if (typeof navigator === 'undefined') return false;
  return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
};

// Enhanced iOS device detection
export const isIOSDevice = () => {
  if (typeof window === 'undefined' || typeof navigator === 'undefined') return false;
  
  const userAgent = window.navigator.userAgent.toLowerCase();
  const platform = (navigator as any).platform || '';
  
  // Check for traditional iOS devices
  const isiOSUserAgent = /iphone|ipad|ipod/.test(userAgent);
  
  // Check for iPadOS (iOS 13+) - Safari on iPad reports as Mac
  const isiPadOS = userAgent.includes('mac') && 'ontouchend' in document;
  
  // Check platform strings for iOS devices
  const isiOSPlatform = /iPhone|iPad|iPod/.test(platform);
  
  // Check for iOS using maxTouchPoints (iOS devices typically have 5+ touch points)
  const hasIOSTouchPoints = navigator.maxTouchPoints && navigator.maxTouchPoints > 1 && 
                            (userAgent.includes('mac') || userAgent.includes('safari'));
  
  // Check for standalone mode (PWA on iOS)
  const isStandalone = (window.navigator as any).standalone === true;
  
  return isiOSUserAgent || isiPadOS || isiOSPlatform || (hasIOSTouchPoints && !userAgent.includes('android')) || isStandalone;
};

// Check if native fullscreen is truly supported and working
export const isNativeFullscreenSupported = () => {
  if (typeof document === 'undefined') return false;
  
  // iOS Safari doesn't support the Fullscreen API properly
  if (isIOSDevice()) return false;
  
  const element = document.documentElement;
  return !!(
    element.requestFullscreen ||
    (element as any).webkitRequestFullscreen ||
    (element as any).mozRequestFullScreen ||
    (element as any).msRequestFullscreen
  );
};

import { createEraserCursor } from '../constants/floorPlanConstants'; // Assuming createEraserCursor is here or accessible
import type { ElementType } from '../types'; // Assuming ElementType is accessible

export const getCursorStyle = (
  hasTouchScreen: boolean,
  isPanning: boolean,
  currentTool: ElementType
): string => {
  if (hasTouchScreen) return 'none';
  if (isPanning) return 'grabbing';
  if (currentTool === 'select') return 'grab';
  if (currentTool === 'eraser') return createEraserCursor(); // Ensure createEraserCursor is imported/available
  return 'default';
}; 